import React from 'react'
import { useEffect, useState } from 'react'
import $ from 'jquery'
import getDomainName from 'helpers/getDomainName'

const DataCollection = ({ workorderId }) => {
  const [embedUrl, setEmbedUrl] = useState()
  const [parameter, setParameter] = useState({
    sessionId: localStorage.getItem('userLoginSessionId'),
    accessToken: localStorage.getItem('accessToken'),
    domain: getDomainName(),
    woId: workorderId,
  })

  const createQueryString = params => {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
  }

  useEffect(() => {
    $('#pageLoading').show()
    ;(async () => {
      try {
        const addQueryParam = `https://egalvanic.retool.com/embedded/public/ae69a92f-a253-4478-94b5-89eba156d3d0?${createQueryString(parameter)}`
        setEmbedUrl(addQueryParam)
        $('#pageLoading').hide()
      } catch (error) {
        $('#pageLoading').hide()
        console.log(error)
      }
    })()
  }, [])

  return <iframe src={embedUrl} title='description' style={{ height: 'calc(100vh - 200px)', width: '100%' }}></iframe>
}

export default DataCollection
